import "./style.scss"

 $(document).ready(function(){
    $('#homeservice h4').click(function() {
        $(this).parent().nextAll('.detail').first().toggle();
        $(this).toggleClass('active');
        if($(window).width() > 1024) {
            if( ($('.free h4').hasClass('active')) && ($('.video h4').hasClass('active'))) {
                $('.video').closest('.content').addClass('active');
            }else{
                $('.video').closest('.content').removeClass('active');
            }
            if( ($('.online h4').hasClass('active')) && ($('.channel h4').hasClass('active'))) {
                $('.online').closest('.content').addClass('active');
            }else{
                $('.online').closest('.content').removeClass('active');
            }
        }
    });   
    $('#homeservice .text-content .detail h4').each(function(){
        if($(this).height() < 40) {
            $(this).css({'margin-top':'20px'})
            $(this).prev('i').css({'margin-top' : '20px'})
        }
    })
 })

